import { AIStatusBadgeStyled } from './styles/AIStatusBadgeStyled'
import { IconMagicSolid } from '@ui/elements/Icon/components'
import { getAnalyticsDataAttrs } from '@ui/utils/analytics'

export interface IAIStatusBadgeProps {
  /**
   * Unique identifier for analytics tracking.
   */
  analyticsId?: string
  text: string
  size?: 'small' | 'medium'
  'aria-label'?: string
}

export const AIStatusBadge = ({
  analyticsId,
  text,
  size = 'medium',
  'aria-label': ariaLabel,
}: IAIStatusBadgeProps) => {
  const analyticsProps = getAnalyticsDataAttrs(analyticsId)

  return (
    <AIStatusBadgeStyled size={size} aria-label={ariaLabel} {...analyticsProps}>
      <IconMagicSolid size={10} block aria-hidden />
      <span>{text}</span>
    </AIStatusBadgeStyled>
  )
}

AIStatusBadge.displayName = 'AIStatusBadge'
